export function currentRoute(state) {
  return state.currentRoute;
}